module.exports = __webpack_public_path__ + "static/pumpkin-gift-3f25bc7a039800e6c121104210261794.png";